import React from "react";
import "./css/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <main className="policy-container">
      <header>
        <span className="tag">Privacy Policy</span>
        <h1>Privacy Policy for Kenny's</h1>
        <p>Last updated: 20 November 2025</p>
      </header>

      <section className="section">
        <p>
          This Privacy Policy explains how{" "}
          <strong>Kenny’s: Fish and Chips</strong> (“we”, “our”, or “us”)
          collects, uses, and protects your information when you use our mobile
          application. By using the app, you agree to the collection and use of
          information in accordance with this policy.
        </p>
      </section>

      <section className="section">
        <h2>1. Information We Collect</h2>
        <p>
          Our app is a basic fish ordering application designed for local
          customers. We use Firebase for user authentication and data storage.
          The information we collect is strictly for order processing and to
          improve your experience with us.
        </p>
        <h3>1.1 Account Information</h3>
        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Phone number (for delivery contact)</li>
          <li>Password (stored securely by Firebase)</li>
        </ul>

        <h3>1.2 Order & Delivery Information</h3>
        <ul>
          <li>Selected fish items and quantities</li>
          <li>Delivery address</li>
          <li>Preferred delivery time (if applicable)</li>
          <li>Order history</li>
        </ul>

        <h3>1.3 Automatically Collected Information</h3>
        <p>
          Firebase may collect some technical information automatically when you
          use the app, including:
        </p>
        <ul>
          <li>Device type and operating system</li>
          <li>App version</li>
          <li>Crash data and performance logs</li>
        </ul>
        <p>This data helps us improve app performance and fix issues.</p>
      </section>

      <section className="section">
        <h2>2. How We Use Your Information</h2>
        <p>We use the information we collect for the following purposes:</p>
        <ul>
          <li>To manage your user account</li>
          <li>To process your fish orders and deliver them</li>
          <li>To contact you about your order (via phone/SMS if necessary)</li>
          <li>To improve our app, services, and user experience</li>
          <li>To ensure app security and prevent fraud</li>
        </ul>
      </section>

      <section className="section">
        <h2>3. Payments & Cash on Delivery</h2>
        <p>
          Our app uses <strong>Cash on Delivery (COD)</strong> only. We do not
          collect or store any credit card or online payment information.
        </p>
        <p>
          Payment is made directly to the delivery person at the time of
          delivery. We do not process or store sensitive financial data.
        </p>
      </section>

      <section className="section">
        <h2>4. Use of Firebase and Third-Party Services</h2>
        <p>
          We use <strong>Google Firebase</strong> for user authentication,
          database/storage, and other backend services. Firebase may process
          some data, and you can read their privacy policy here:{" "}
          <a
            href="https://firebase.google.com/support/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Firebase Privacy Policy
          </a>
        </p>
        <p>
          We do not sell, trade, or rent your personal information. We only
          share necessary data with Firebase and our service providers to
          operate the app and deliver your orders.
        </p>
      </section>

      <section className="section">
        <h2>5. Data Storage, Security & Retention</h2>
        <p>
          Your data is stored securely in Firebase. We implement technical
          measures to protect your information. However, no method of
          transmission over the internet or electronic storage is 100% secure,
          so we cannot guarantee absolute security.
        </p>
        <p>
          We retain your data as long as it’s needed to provide services,
          fulfill legal obligations, or as required by law in{" "}
          <strong>South Africa</strong>.
        </p>
      </section>

      <section className="section">
        <h2>6. Your Rights & Choices</h2>
        <p>Depending on your region, you may have rights to:</p>
        <ul>
          <li>Access your personal information</li>
          <li>Request correction of inaccurate data</li>
          <li>Request deletion of your account and data</li>
        </ul>
        <p>
          To exercise these rights, contact us at{" "}
          <strong>kennygovender1904@gmail.com</strong>. We may require identity
          verification before processing requests.
        </p>
      </section>

      <section className="section">
        <h2>7. Children’s Privacy</h2>
        <p>
          Our app is not intended for children under the age of 13. We do not
          knowingly collect personal data from children under 13. If we learn
          that we have unintentionally collected such data, we will take steps
          to delete it.
        </p>
      </section>

      <section className="section">
        <h2>8. Cookies & Tracking</h2>
        <p>
          Our mobile app does not use cookies. However, Firebase and other
          third-party services may use identifiers and similar technologies for
          performance tracking and analytics.
        </p>
      </section>

      <section className="section">
        <h2>9. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Any changes will
          be posted within the app or updated on this page with a new "Last
          updated" date. We encourage you to periodically review this policy to
          stay informed about how we protect your information.
        </p>
      </section>

      <section className="section">
        <h2>10. Contact Us</h2>
        <p>
          If you have questions about this Privacy Policy or your data, you can
          contact us:
        </p>
        <ul>
          <li>
            <strong>Business:</strong> Kenny’s Fish and Chips
          </li>
          <li>
            <strong>Email:</strong> kennygovender1904@gmail.com
          </li>
          <li>
            <strong>Phone:</strong> +27 83 787 6108
          </li>
          <li>
            <strong>Country:</strong> South Africa
          </li>
        </ul>
      </section>
    </main>
  );
};

export default PrivacyPolicy;
